import { useMemo } from "react"
import { useGetAmenitiesQuery } from "../../services/bClientApi"
import { AmenityType } from "../../Types/amenityTypes"

export default function useAmenitySelectValues() {
    const { data: amenitiesData } = useGetAmenitiesQuery({
        amenitiesQuery: { isActive: true },
        pagination: { page: 1, limit: 1000 }
    })

    const amenityOptions = useMemo(() => {
        if (!amenitiesData?.docs) return []
        return amenitiesData.docs.map((amenity: AmenityType) => ({
            value: amenity._id,
            text: amenity.title,
        }))
    }, [amenitiesData])

    return amenityOptions
}
